<template>
	    <!-- 批量更改弹窗 -->
	<div v-if="data.isShow">
	    <div class="mask batch-change">
	        <div class="e-modal medium">
	            <div class="e-modal-title">批量更改 <i class="e-modal-close" @click="data.isShow=false"></i></div>
	            <div class="e-modal-body">
		            <div class="emb-list">
	            		<div class="embl-content" v-for="room in  roomList">
		            		<div class="embl-left">
		            			<label :for="room.RPS[0].RateId+room.RPS[0].RoomId">
		            				<input type="checkbox" :id="room.RPS[0].RateId+room.RPS[0].RoomId" @change="checkboxChange(room)" v-model="room.checked"  />{{room.Name}}
		            			</label>
		            		</div>
		            		<div class="embl-right" >
		            			<div class="emblr-tag" v-for="rps in room.RPS">
		            				<label :for="rps.RateId" >
		            					<input type="checkbox" :id="rps.RateId"  v-model="rps.active" />
		            					{{rps.PriceTypeName+'&nbsp;&nbsp;&nbsp;'+rps.RatePlanName}}
		            				</label>
		            			</div>
		            		</div>	
	            		</div> 
	            	</div>
	                <ul class="change-type">
	                    <li :class="isActivePage=='custom'?'active':''" @click="isActivePage='custom'">自定义调整</li>
	                    <li :class="isActivePage=='month'?'active':''" @click="isActivePage='month'">按月调整</li>
	                    <li :class="isActivePage=='timeSlot'?'active':''" @click="isActivePage='timeSlot'">时间段调整</li>
	                </ul>
	                <!-- type-content -->
	                <!-- 自定义调整 -->
                    <div :class="isActivePage=='custom'?'type-content active':'type-content'" >
                        <div class="left">
    						<datePicker  @on-date-chage="onDateChange" ></datePicker>
                        </div>
                        <div class="right">
                            <div class="body-item">
                            	<span class="label">价格： </span>
                            	<label for=""><input type="text" v-model="Price" onKeyPress="if((event.keyCode<48 || event.keyCode>57) && event.keyCode!=46 || /\.\d\d$/.test(value))event.returnValue=false"   onkeyup="value=value.replace(/[\u4e00-\u9fa5]/g,'')" /></label>
                            </div>
                            <div class="body-item">
                            	<span class="label">取消： </span>
                            	<input type="radio" name="canCancel1" v-model="canCancel" :value="true"/>
                            	<label for="" class="select-label pstRel" style="margin-right:0">
	                            	<select name="" id="" v-model="CutDay" style="margin-right:0" :disabled="!canCancel">
																	<option value="0">当天</option>
																	<option value="1">1</option>
																	<option value="2">2</option>
																	<option value="3">3</option>
																	<option value="4">4</option>
																	<option value="5">5</option>
																	<option value="6">6</option>
																	<option value="7">7</option>
																	<option value="8">8</option>
																	<option value="9">9</option>
																	<option value="10">10</option>
																	<option value="11">11</option>
																	<option value="12">12</option>
																	<option value="13">13</option>
																	<option value="14">14</option>
																	<option value="15">15</option>
	                              </select>
                            	</label>天
                            	<label class="select-label pstRel" for="" >
                            		<select name="" id="" v-model="CutTime" :disabled="!canCancel">
																	<option value="23:59">23:59</option>
																	<option value="12:00">12:00</option>
																	<option value="13:00">13:00</option>
																	<option value="14:00">14:00</option>
																	<option value="15:00">15:00</option>
																	<option value="16:00">16:00</option>
																	<option value="17:00">17:00</option>
																	<option value="18:00">18:00</option>
																	<option value="19:00">19:00</option>
																	<option value="20:00">20:00</option>
																	<option value="21:00">21:00</option>
																	<option value="22:00">22:00</option>
																	<option value="23:00">23:00</option>
                            		</select>
                            	</label>
															<span>前取消</span>
                            </div>
                            
                            <div class="body-item">
                            	<span class="label"></span>
                            	<input type="radio" name="canCancel1" v-model="canCancel" :value="false"/>
                            	<label for="notAllowCancel11">
                            		<!-- <input type="checkbox" id="notAllowCancel11" v-model="NotAllowCancel" :disabled="canCancel" /> -->

                            		不可取消
                            	</label>
                            </div>
                        </div>
                    </div>
	                <!-- type-content -->
					<!-- //按月调整 -->
	                <div :class="isActivePage=='month'?'type-content active':'type-content'" >
	                    <div class="choose-date">
	                        <div class="select ">
	        					<select name="year" v-model="year">
		                            <option :value="year" v-for="year in years" >{{year}}年</option>
		                        </select>
	                        </div>
	                        <a href="javascript:void(0)" class="arrow-left" @click="lastMonth"></a>                        
	                        <div class="select">
		                        <select name="month" v-model="month">
		                            <option :value="month" v-for="month in ['01','02','03','04','05','06','07','08','09','10','11','12']">{{month}}月</option>
		                        </select>
	                        </div>
	                        <a href="javascript:void(0)" class="arrow-right" @click="nextMonth"></a>                        
	                    </div>
	                    <div class="body-item">
	                        <span class="label">星期：</span>
							<label :for="'weekday'+index" v-for="(day,index) in WeekDays2" >
								<input type="checkbox" :id="'weekday'+index"  :checked="day.checked"  @click="day.checked=!day.checked">{{day.name}}
							</label>
	                    </div>
	              		<div class="body-item">
                            <span class="label">价格： </span>
                            <label for=""><input type="text"  v-model="moPrice" onKeyPress="if((event.keyCode<48 || event.keyCode>57) && event.keyCode!=46 || /\.\d\d$/.test(value))event.returnValue=false"   onkeyup="value=value.replace(/[\u4e00-\u9fa5]/g,'')" /></label>
                        </div>
                        <div class="body-item">
                            <span class="label">取消： </span>
                            <input type="radio" name="canCancel2" v-model="moCanCancel" :value="true"/>
                            <label for="" class="select-label pstRel" style="margin-right:0"> 
                                <select name="" id="" v-model="moCutDay" style="margin-right:0" :disabled="!moCanCancel">
																	<option value="0">当天</option>
																	<option value="1">1</option>
																	<option value="2">2</option>
																	<option value="3">3</option>
																	<option value="4">4</option>
																	<option value="5">5</option>
																	<option value="6">6</option>
																	<option value="7">7</option>
																	<option value="8">8</option>
																	<option value="9">9</option>
																	<option value="10">10</option>
																	<option value="11">11</option>
																	<option value="12">12</option>
																	<option value="13">13</option>
																	<option value="14">14</option>
																	<option value="15">15</option>
                                </select>
                            	
                            </label>天
                            <label class="select-label pstRel" for="" style="margin-right:0">
                                <select name="" id="" v-model="moCutTime" :disabled="!moCanCancel" style="margin-right:0">
																	<option value="23:59">23:59</option>
																	<option value="12:00">12:00</option>
																	<option value="13:00">13:00</option>
																	<option value="14:00">14:00</option>
																	<option value="15:00">15:00</option>
																	<option value="16:00">16:00</option>
																	<option value="17:00">17:00</option>
																	<option value="18:00">18:00</option>
																	<option value="19:00">19:00</option>
																	<option value="20:00">20:00</option>
																	<option value="21:00">21:00</option>
																	<option value="22:00">22:00</option>
																	<option value="23:00">23:00</option>
                                </select>
                            </label>前取消
                        </div>
                        <div class="body-item">
                            <span class="label"></span>
                            <input type="radio" name="canCancel2" v-model="moCanCancel" :value="false"/>
                            <label for="notAllowCancel12">

                            	<!-- <input type="checkbox" id="notAllowCancel12" v-model="moNotAllowCancel" :disabled="moCanCancel"/> -->

                            不可取消</label>
                        </div>
	                </div>



	                <!-- type-content -->
	                <!-- // 时间段调整 -->
	                <div :class="isActivePage=='timeSlot'?'type-content active':'type-content'" >
	                    <div class="body-item">
	                        <span class="label calendar-position">时间：</span>
	                        <label for="" >
	                        	<input type="text" class="date-choose-input calendarBegin" v-model="beginSlot" name="date" @click="calendar.show=true">
	                        	<input type="text" class="date-choose-input calendarEnd" id="dateEnd11" v-model="endSlot" @click="calendar2.show=true"  name="date">
	                        </label>
	                        <calendar v-if="calendar.show" :zero="calendar.zero" :lunar="calendar.lunar" :value="calendar.value" :begin="calendar.begin"  @select="calendar.select"></calendar>
	                        <calendar style="margin-left:204px" v-if="calendar2.show" :zero="calendar2.zero" :lunar="calendar2.lunar" :value="calendar2.value" :begin="calendar2.begin"  @select="calendar2.select"></calendar>

	                      <!--   <calendar v-if="calendar.show" :events="calendar.events" :range="calendar.range" :begin="calendar.begin" :zero="calendar.zero" :lunar="calendar.lunar" :value="calendar.value"  @select="calendar.select">
               				</calendar> -->
	                    </div>

	                    <div class="body-item">
	                        <span class="label">星期：</span>
							<label v-for="(day,index) in WeekDays3" :for="'weekday2'+index" >
								<input type="checkbox" :id="'weekday2'+index"  :checked="day.checked"  @click="day.checked=!day.checked">{{day.name}}
							</label>
	                    </div>

	           			<div class="body-item">
                            <span class="label">剔除：</span>
                            <label for="" >
                            	<input type="text" class="date-choose-input" name="date" v-model="beginSlotExcept" @click="calendar3.show=true">
                            	<input  type="text" class="date-choose-input" name="date" id="dateEnd12" v-model="endSlotExcept" @click="calendar4.show=true">
                            </label>
                     

                			<calendar v-if="calendar3.show" :zero="calendar3.zero" :lunar="calendar3.lunar" :value="calendar3.value" :begin="calendar3.begin" :end="calendar3.end"  @select="calendar3.select" ></calendar>
	                        <calendar style="margin-left:204px" v-if="calendar4.show" :zero="calendar4.zero" :lunar="calendar4.lunar" :value="calendar4.value" :begin="calendar4.begin" :end="calendar4.end" @select="calendar4.select"></calendar>



                        </div>

                        <div class="body-item">
                            <span class="label">价格： </span>
                            <label for=""><input type="text" v-model="slotPrice" onKeyPress="if((event.keyCode<48 || event.keyCode>57) && event.keyCode!=46 || /\.\d\d$/.test(value))event.returnValue=false"   onkeyup="value=value.replace(/[\u4e00-\u9fa5]/g,'')" /></label>
                        </div>

                        <div class="body-item">
                            <span class="label">取消： </span>
                            <input type="radio" name="canCancel3" v-model="slotCanCancel" :value="true"/>

                            <label for="" class="select-label pstRel" style="margin-right:0" >
                                <select name="" id="" v-model="slotCutDay" style="margin-right:0" :disabled="!slotCanCancel">
																	<option value="0">当天</option>
																	<option value="1">1</option>
																	<option value="2">2</option>
																	<option value="3">3</option>
																	<option value="4">4</option>
																	<option value="5">5</option>
																	<option value="6">6</option>
																	<option value="7">7</option>
																	<option value="8">8</option>
																	<option value="9">9</option>
																	<option value="10">10</option>
																	<option value="11">11</option>
																	<option value="12">12</option>
																	<option value="13">13</option>
																	<option value="14">14</option>
																	<option value="15">15</option>
                                </select>
                            </label>天
                            <label class="select-label pstRel"  v-show="!calendar2.show&&!calendar.show" for="" style="margin-right:0">
                                <select name="" id="" v-model="slotCutTime" :disabled="!slotCanCancel" style="margin-right:0">
																	<option value="23:59">23:59</option>
																	<option value="12:00">12:00</option>
																	<option value="13:00">13:00</option>
																	<option value="14:00">14:00</option>
																	<option value="15:00">15:00</option>
																	<option value="16:00">16:00</option>
																	<option value="17:00">17:00</option>
																	<option value="18:00">18:00</option>
																	<option value="19:00">19:00</option>
																	<option value="20:00">20:00</option>
																	<option value="21:00">21:00</option>
																	<option value="22:00">22:00</option>
																	<option value="23:00">23:00</option>
                                </select>
                            </label>前取消
                        </div>
                        <div class="body-item">
                            <span class="label"></span>
                            <label for="notAllowCancel13">
                            	<input type="radio" name="canCancel3" v-model="slotCanCancel" :value="false"/>
                            	<!-- <input type="checkbox" id="notAllowCancel13" v-model="slotNotAllowCancel" :disabled="slotCanCancel"> -->
                            	不可取消
                            </label>
                        </div>
	                </div> 
	            </div>
	            <div class="e-modal-footer">
	                <div class="short-btn save-btn" @click="save">保存</div>
	                <div class="short-btn cancel-btn" @click="data.isShow=false">取消</div>                                
	            </div>
	        </div>
	    </div>

     
	</div>
	
</template>

<script>
import datePicker from './../DatePicker.vue'
import Calendar from './../../../../common/calendar/calendar.vue'//日期选择器
export default {
    name:'roomPriceBatch',
    components:{
    	datePicker,
    	Calendar
    },
    props:{
    	cmData:{
    		type:Object,
    		default:function(){
    			return{}
    		}
    	},
    	rps:{
    		type:Object,
    		default:function(){
    			return{}
    		}
    	},
    	cmroomList:{
    		type:Array,
    		default:function(){
    			return[]
    		}
    	}
    },
    data(){
    	return{
    		data:{},
    		isActivePage:"custom",
    		hotelId:this.dao.get('HotelId'),
    		years:this.getYears(),
    		year:this.getYears()[0],
    		month:this.getMonth(),
    		beginSlotExcept:'',
    		beginSlot:'',
    		endSlot:'',
    		endSlotExcept:'',
    		DateRangeDates:'',
			calendar:{
		        display:"",
		        show:false,
		        zero:true,
		        value:[],
		        lunar:false, //显示农历
		        select:(value)=>{
		            if(!value){
		                this.calendar.show=false;
		                return;
		            }
		            this.beginSlot=value.join('-');
		            this.calendar.value=value;
		            this.calendar2.begin=value;
		            this.calendar3.begin=value;
					this.calendar2.value=value;
					this.calendar3.value=value;
		            this.endSlot='';
		            this.calendar2.show=true;
		            this.calendar.show=false;
		            var end=document.getElementById('dateEnd11');
		            end.focus();
		        }
		    },
		    calendar2:{
		        display:"",
		        show:false,
		        zero:true,
		        // begin:'', //默认日期
		        value:[],
		        lunar:false, //显示农历
		        select:(value)=>{
		        	
		            if(!value){
		                this.calendar2.show=false;
		                return;
		            }
		            this.endSlot=value.join('-');
		           
		            this.calendar2.value=value;
		            this.calendar4.end=value;
		            this.calendar3.end=value;
		            this.calendar2.show=false;
		            // this.calendar.display=value.join("-");
		        }
		    },
			calendar3:{
		        display:"",
		        show:false,
		        zero:true,
		        value:[],
		        lunar:false, //显示农历
		        select:(value)=>{
		            if(!value){
		                this.calendar3.show=false;
		                return;
		            }
		            this.beginSlotExcept=value.join('-');
		            this.calendar3.value=value;
		            this.calendar4.begin=value;
					this.calendar4.value=value;
		            this.endSlotExcept='';
		            this.calendar4.show=true;
		            this.calendar3.show=false;
		            var end=document.getElementById('dateEnd12');
		            end.focus();
		        }
		    },
		    calendar4:{
		        display:"",
		        show:false,
		        zero:true,
		        // begin:'', //默认日期
		        value:[],
		        lunar:false, //显示农历
		        select:(value)=>{
		        	
		            if(!value){
		                this.calendar4.show=false;
		                return;
		            }
		            this.endSlotExcept=value.join('-');
		           
		            this.calendar4.value=value;
		            this.calendar4.show=false;
		            // this.calendar.display=value.join("-");
		        }
		    },


		    //自定义调整
			Currency: '',
			Price: 0,
			NotAllowCancel: false,
			CutDay: 0,
			CutTime: '17:00',
			canCancel:false,
			//按月调整
			moCurrency: '',
			moPrice: 0,
			moNotAllowCancel: false,
			moCutDay: 0,
			moCutTime: '17:00',
			moCanCancel:false,
			// 时间段调整
			slotCurrency: '',
			slotPrice: 0,
			slotNotAllowCancel: false,
			slotCutDay: 0,
			slotCutTime: '17:00',
			slotCanCancel:false,
			roomList:[],
		    //自定义调整
		    WeekDays:[
				{
					value:1,
					name:'星期一',
					checked:true
				},
				{
					value:2,
					name:'星期二',
					checked:true
				},
				{
					value:3,
					name:'星期三',
					checked:true
				},
				{
					value:4,
					name:'星期四',
					checked:true
				},
				{
					value:5,
					name:'星期五',
					checked:true
				},
				{
					value:6,
					name:'星期六',
					checked:true
				},
				{
					value:0,
					name:'星期日',
					checked:true
				},
		    ],
		      //按月调整
		    WeekDays2:[
				{
					value:1,
					name:'星期一',
					checked:true
				},
				{
					value:2,
					name:'星期二',
					checked:true
				},
				{
					value:3,
					name:'星期三',
					checked:true
				},
				{
					value:4,
					name:'星期四',
					checked:true
				},
				{
					value:5,
					name:'星期五',
					checked:true
				},
				{
					value:6,
					name:'星期六',
					checked:true
				},
				{
					value:0,
					name:'星期日',
					checked:true
				},
		    ],
		    // 时间段调整
		    WeekDays3:[
				{
					value:1,
					name:'星期一',
					checked:true
				},
				{
					value:2,
					name:'星期二',
					checked:true
				},
				{
					value:3,
					name:'星期三',
					checked:true
				},
				{
					value:4,
					name:'星期四',
					checked:true
				},
				{
					value:5,
					name:'星期五',
					checked:true
				},
				{
					value:6,
					name:'星期六',
					checked:true
				},
				{
					value:0,
					name:'星期日',
					checked:true
				},
		    ]
    	}
    },
    watch:{

    	cmData(val){
			this.data=val;
    	},
    	cmroomList(val){
			this.roomList=val
    
    	},
    },

    methods:{
	  	lastMonth(){
	  		var now=this.year+'-'+this.month;
	  		if(this.getSearchMonth(now,-1)[0]<this.getYears()[0]){
	  			return;
	  		}
	  		this.month=this.getSearchMonth(now,-1)[1];
	  		this.year=this.getSearchMonth(now,-1)[0];

	  	},
	  	nextMonth(){
			var now=this.year+'-'+this.month;
			if(this.getSearchMonth(now,1)[0]>this.getYears()[4]){
	  			return;
	  		}
	  		this.month=this.getSearchMonth(now,1)[1];
	  		this.year=this.getSearchMonth(now,1)[0];
	  	},
	  	getSearchMonth(dat,count){
	  		var date = new Date(dat);
			
	        date.setMonth(date.getMonth() + count,1);
	        var year = date.getFullYear();
	        var month = date.getMonth() + 1;
	        if (month < 10) { month = '0' + month };
	        month=String(month);
	        return [year,month];
	  	},

    	onDateChange(date){
    		this.DateRangeDates=date;
    	},
		getYears(){
			var da = new Date();
            var year=da.getFullYear();
            var result=[];
            for(var i=0;i<2;i++){
            	result.push(year+i)
            }
			return result
		},
		getMonth(){
			var da = new Date();
            var month = da.getMonth()+1;
            if(month<10){month='0'+month};
			return month
		},
		getAllRps(){
			var list=[];
			var roomList=this.roomList;
			for(var i=0;i<roomList.length;i++){
				
				roomList[i].RPS.forEach(function(item){
					if(item.active){
						var obj={
							HotelID: item.HotelId,
				          	RoomID: item.RoomId,
				          	RPID: item.RatePlanId,
				          	RateID: item.RateId,		
						}
						list.push(obj)
					}

				})
			}
			return list;
		},

	  	//全选或者反选酒店
		checkboxChange(room){
			
			var that=this;
			that.$nextTick(function () {
	            that.$set(room,'checked',room.checked);
	    　　 });

			var status=room.checked;
		
			room.RPS.forEach(function(item){
				
			
				that.$set(item,'active',status);
			})

		},
		getAllDays(s1,s2){
		
			var count=this.getDaysSize(s1,s2);
			var days=[];
			for(var i=0;i<=count;i++){
				var d=this.getEveryDay(s1,i);
				days.push(d);
			
			}
			return days;

		},
		getEveryDay(s1,count){
			var date = new Date(s1);
            date.setDate(date.getDate() + count); //获取count天后的日期 
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (day >= 0 && day <= 9) {
                day = "0" + day;
            }

            var time = year + '/' + month + '/' + day;
            return time;

		},

        save () {
	        var that=this;
			
			var DateRange={};
			var params={};//请求参数
		    var WeekDays=[];

			if (!that.getAllRps()||that.getAllRps().length<=0){
	            that.error({title: '修改出错',content: '请选择酒店rp'})
	            return;
	        }
			//自定义调整
			if(that.isActivePage=='custom'){
				var DateRangeDateslist=that.DateRangeDates;
				if(!DateRangeDateslist){
					that.error({title: '修改出错',content: '请选择日期'})
					return;
				}
	    		if(!that.Price||that.Price<0){
	    			that.error({ title: '提示', content: '价格不能小于0' });
	    			return;
	    		}

	    		if(that.Price>100000000){
	    			that.error({ title: '提示', content: '价格不能大于100000000' });
	    			return;
	    		}
				DateRangeDateslist.shift();
				DateRange={
	                Type: 0,
	                Dates:DateRangeDateslist,
	                WeekDays:null,
	                Excepts:null
	            }
	            params={
					RPs:that.getAllRps(),
			        Currency: that.Currency,
			        Price: that.Price,
			        NotAllowCancel: !that.canCancel,
			        CutDay: that.CutDay||0,
			        CutTime: that.CutTime,
			        DateRange:DateRange
		        }
	        //按月调整
			}else if(that.isActivePage=='month'){
				that.WeekDays2.forEach(function(day){
		        	if(day.checked){
						WeekDays.push(day.value)
		        	}
		        })
    			if(!that.moPrice||that.moPrice<0){
	    			that.error({ title: '提示', content: '价格不能小于0' });
	    			return;
	    		}

	    		if(that.moPrice>100000000){
	    			that.error({ title: '提示', content: '价格不能大于100000000' });
	    			return;
	    		}
				DateRange={
	                Type: 1,
	                Year:that.year,
	                Month:that.month,
	                WeekDays: WeekDays,
	                Excepts:''
	            }
	            params={
					RPs:that.getAllRps(),
			        Currency: that.moCurrency,
			        Price: that.moPrice,
			        NotAllowCancel: !that.moCanCancel,
			        CutDay: that.moCutDay||0,
			        CutTime: that.moCutTime,
			        DateRange:DateRange
		        }
			//时间段调整
			}else if(that.isActivePage=='timeSlot'){

				if (!that.beginSlot||!that.endSlot){
		            that.error({title: '修改出错',content: '请选择时间段'})
		            return;
		        }
		        if(!that.slotPrice||that.slotPrice<0){
	    			that.error({ title: '提示', content: '价格不能小于0' });
	    			return;
	    		}

	    		if(that.slotPrice>100000000){
	    			that.error({ title: '提示', content: '价格不能大于100000000' });
	    			return;
	    		}
		        var allDays=that.getAllDays(that.beginSlotExcept,that.endSlotExcept);
				
		        that.WeekDays3.forEach(function(day){
		        	if(day.checked){
						WeekDays.push(day.value)
		        	}
		        })
				DateRange={
	                Type: 2,
	                Start:that.beginSlot,
	                End:that.endSlot,
	                WeekDays: WeekDays,
	                Excepts:allDays
	            }
	            params={
					RPs:that.getAllRps(),
			        Currency: that.slotCurrency,
			        Price: that.slotPrice,
			        NotAllowCancel: !that.slotCanCancel,
			        CutDay: that.slotCutDay||0,
			        CutTime: that.slotCutTime,
			        DateRange:DateRange
		        }
			}

	        that.patchRequest({
	            url: that.Api.batchPrice,
	            params: JSON.stringify(params)
	        }).then(res => {
	           
	            if (res&&res.IsSuccess) {
	                that.data.isShow=false;
	                this.$emit('saveDate')
	            } else {
	                that.error({ title: '提示', content: '提交失败，请重新提交' });
	            }
	        });
	    },
    },
    mounted(){
    	this.roomList=this.cmroomList;
    	
    }
}
	
</script>


// WEBPACK FOOTER //
// src/components/roomPrice/psComponent/roomPriceEdit/RoomPriceBatch.vue